import { render, staticRenderFns } from "./SavedViewsList.vue?vue&type=template&id=36502e62"
import script from "./SavedViewsList.vue?vue&type=script&lang=js"
export * from "./SavedViewsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports